/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */
import React from 'react';
import { connect } from "react-redux";
import {
    Header,
    HeaderName,
    SkipToContent
} from "@carbon/react";

function render(props) {
  const defaultMessage = `The login credentials presented are invalid.
        Please contact your local database administrator to ask the credentials be updated to reflect valid values.`
  const errormessage = props.location && props.location.state && props.location.state.errorMessage;

  const resultMessage = errormessage ? errormessage : defaultMessage;

  return (
    <div className="Login">
      <Header aria-label="Merative Platform Name" className="chatbot-custom-header">
        <SkipToContent />
        <HeaderName href="#" prefix="Merative">
          Micromedex®
        </HeaderName>
      </Header>
      <div className="mdx-loginBannerImg">
        <img size="small" src="images/micromedex-lead.png" alt="" className='login-image' />
      </div>

      <div className="mdx-login-content">
        <link rel="manifest" href="%PUBLIC_URL%/manifest.json"></link>

        <div className="Login">
          <div className='ip-login-txt'>
            {
              resultMessage
            }
          </div>
          <div className='support-data'>
                            <span>
                                24 x 7 Technical Support and Call Center Access are available from&nbsp;
                                <a target="_blank"
                                   rel="noopener noreferrer"
                                   style={{ color: "#0058e4" }}
                                   href="https://merative.my.site.com/mysupport/s/micromedex-support-request">
                                    Micromedex Support
                                    </a>
                            </span>
          </div>
          <div className='support-data'>
                            <span>
                                U.S. and Canada Phone: 1-877-843-6796
                                    <br />
                                    Global: +1.734.768.1510
                                    <br />
                                <a target="_blank"
                                   rel="noopener noreferrer"
                                   style={{ color: "#0058e4" }}
                                   href="https://www.merative.com/contact">
                                    Contact Us
                                    </a>
                            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = dispatch => {
    return {}
}

const mapStateToProps = state => {
    return {}
}

export const ErrorPagePresentation = (props) => (render(props))

export const ErrorPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(ErrorPagePresentation)

export default ErrorPage;
